module.exports = __webpack_public_path__ + "static/img/7.da297ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/7.png
// module id = WgVt
// module chunks = 0